import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Location, DatePipe } from '@angular/common';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { CommonService } from 'src/app/services/common.service';
import { TransferOwnershipDto } from 'src/app/model/qModel.model';
import { ApiService } from 'src/app/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

declare let $: any;
@Component({
  selector: 'app-change-owner',
  templateUrl: './change-owner.component.html',
  styleUrls: ['./change-owner.component.scss']
})
export class ChangeOwnerComponent implements OnInit {

  // subscription: Subscription;
  // browserRefresh: boolean = false;

  constructor(private _router: Router, private _toastr: ToastrService, private location: Location, private _formBuilder: FormBuilder, private _commonService: CommonService, private _service: ApiService) {
    //   this.subscription = _router.events.subscribe((event) => {
    //     if (event instanceof NavigationStart) {
    //       this.browserRefresh = !_router.navigated;
    //     }
    // });
  }

  currentDeviceOwner: any;
  isOwnership: boolean = false;
  isLoading: boolean = false;
  transferDto: TransferOwnershipDto = new TransferOwnershipDto();
  deviceIdList = new Set();
  isTransferOwnershipSuccess: boolean = false;
  allChecked: boolean = false;
  getUserDeviceData: any;
  individualChecked: boolean = false;
  loggedInUser: any;
  getTransferOwnershipUser: any;
  userId: any;
  ngOnInit(): void {
    const previousUrl = history.state.prevPage ?? null;
    if (!previousUrl) {
      this.location.back();
    } else {
      if (this._commonService.userData) {
        this.currentDeviceOwner = this._commonService.userData;
      }
      let currentUser = localStorage.getItem('currentUser');
      if (currentUser) {
        this.loggedInUser = JSON.parse(currentUser);
      }
      this.getDeviceByUserId();
      this.gettransferownershipuser();
    }
  }

  transferOwnershipForm: FormGroup = new FormGroup({
    assignedUserId: new FormControl(''),

  });

  goBack() {
    this.location.back();
  }
  //  Transfer Ownership To Assigned User
  onTransferOwnership() {
    try {
      this.transferDto.currentUserId = this.currentDeviceOwner.id;
      this.transferDto.deviceIdList = Array.from(this.deviceIdList);
      this.transferDto.assignedUserId = this.transferOwnershipForm.controls['assignedUserId'].value;
      this._service.putService(this._service.API_URL.manageDeviceTransferOwnership, this.transferDto).subscribe((response: any) => {
        if (response.status.code === 200) {
          this.deviceIdList = new Set();
          this.isOwnership = false;
          this.isTransferOwnershipSuccess = true;
          this.getDeviceByUserId();
          //this.getAllUser();
          $("#ChangedOwnerSuccess").modal("show");
        }
        else {
          this._toastr.error('', response.status.message);
        }
      })
    } catch (error) {
      console.log(error);

    }
  }
  getUser: any
  transferOwnershipUsername(evt: any) {
    this.getTransferOwnershipUser?.forEach((element?: any) => {
      if (element.id === evt) {
        this.getUser = element.name;
      }
    });
    if (evt == this.loggedInUser.id) {
      this.getUser = this.loggedInUser.name
    }
  }

  //  Fetching all the user For Assigning to the Transfer Ownership Modal(Popup)
  gettransferownershipuser() {
    try {
      this._service.getService(this._service.API_URL.gettransferownershipuser).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          if (this.currentDeviceOwner.id != this.loggedInUser.id) {
            response.data.push(this.loggedInUser);
          }
          let index = -1;
          response.data.forEach((element: any, i: any) => {
            if (element.avatarUrl) {
              this.getDownloadPreSignedurl(element)
            }
            if (this.currentDeviceOwner.id == element.id) {
              index = i;
            }
          });
          if (index > -1) {
            response.data.splice(index, 1);
          }
          this.getTransferOwnershipUser = response.data;
        }
      })
    } catch (error) {

    }
  }


  getDownloadPreSignedurl(element: any) {
    try {
      this._service.getService(this._service.API_URL.getDownloadPreSignedurl + "?objectKey=" + element.avatarUrl).subscribe((response) => {
        if (response && response.status.code === 200) {
          element.avatarUrl = response.data.avatarUrl;
        }
      })
    } catch (error) {

    }
  }
  // Get User By UserId

  getDeviceByUserId() {
    this._service.getService(this._service.API_URL.getDeviceByUserId + '/' + this.currentDeviceOwner.id).subscribe((response) => {
      if (response && response.status.code === 200) {
        this.getUserDeviceData = response.data.myDeviceList;
        if (this.getUserDeviceData?.length === 1) {
          this.individualChecked = true;
          this.allChecked = true;
          this.deviceIdList.add(this.getUserDeviceData[0].id)
        } else {
          this.individualChecked = false;
          this.allChecked = false;
        }
      }
    })
  }
  //  Fetching the Device Id here and Passing the data to the TransferOwnership for Transfer Ownership
  onDeviceClick(event: any, data: any, type: string) {
    if (type == 'single') {
      if (event.target.checked && !this.allChecked) {
        this.deviceIdList.add(data.id);
        this.allChecked = this.getUserDeviceData?.length == this.deviceIdList.size;
      }
      else {
        this.allChecked = false
        this.deviceIdList.delete(data.id)
        this.individualChecked = this.deviceIdList.size > 0

      }
    }
    else {
      if (event.target.checked) {
        data.forEach((element: any) => {
          this.allChecked = true
          this.individualChecked = true
          this.deviceIdList.add(element.id);
        })
      }
      else {
        data.forEach((element: any) => {
          this.individualChecked = false
          this.allChecked = false
          this.deviceIdList.delete(element.id);
        })
      }
    }
  }
  trackByFn(item: any) {
    return item.id;
  }
  closeSuccessModal() {
    $("#ChangedOwnerSuccess").modal("hide")
    this.location.back();
  }

}
